export const KEYBOARD_KEY = {
    NEW_NOTE: 78, //N key
    FLAT: 66, //B key
    SHARP: 51, // 3(#) key
    NATURAL: 77, //M key
    UP_KEY: 38, //UP
    DOWN_KEY: 40, //DOWN
    LEFT_KEY: 37, //LEFT
    RIGHT_KEY: 39, //RIGHT
    PAUSE: 80, //P key
    DOT: 190, //.(>) key
};

export const TICKABLE_TYPE = {
    NOTE: 'note',
    REST: 'rest',
    BAR: 'bar',
    CLEF: 'clef',
};

export const CLEF_OFFSETS = {
    treble: 0,
    bass: -21,
    alto: -10,
    tenor: -14,
    percussion: 0,
    soprano: -4,
    'mezzo-soprano': -7,
    'baritone-c': -17,
    'baritone-f': -17,
    subbass: -24,
    french: 6,
};

export const PROVISORY_TICKABLE_STYLE = {
    shadowBlur: 0,
    shadowColor: 'gray',
    fillStyle: 'gray',
    strokeStyle: 'gray',
};
export const HIGHLIGHT_NOTE_STYLE = {
    shadowBlur: 15,
    shadowColor: 'red',
    fillStyle: 'black',
    strokeStyle: 'black',
};
export const DEFAULT_NOTE_STYLE = {
    shadowBlur: 0,
    shadowColor: 'black',
    fillStyle: 'black',
    strokeStyle: 'black',
};
